/**
 * Baked set of fund slugs that are rendered by the Dane reference site.
 * Used to gate the Active/Passive management pill on fund cards — only
 * Dane-tracked funds show the pill (static-new-only funds correctly omit it).
 *
 * Interim constant; will later derive from a server flag on the fund record.
 * Source: .claude-scratch/reference-selector.json (all entries with value "dane").
 */
export const DANE_TRACKED_FUNDS: ReadonlySet<string> = new Set([
  "all-world-2x",
  "av",
  "bay",
  "blck",
  "brew",
  "brzx",
  "bzz",
  "cbil",
  "cbot",
  "ccpx",
  "cgov",
  "chyg",
  "ciei",
  "civg",
  "cjun",
  "cmag",
  "cmay",
  "cqtm",
  "ctjn",
  "ctma",
  "cust",
  "dipr",
  "dock",
  "emjn",
  "emmy",
  "emxx",
  "euv",
  "euvx",
  "eyes",
  "fdrs",
  "fdrx",
  "gasz",
  "glam",
  "gnmx",
  "hjun",
  "hmay",
  "hull",
  "idjn",
  "idmy",
  "joul",
  "junc",
  "krwx",
  "kyc",
  "latr",
  "mayc",
  "mgkx",
  "nyny",
  "oddz",
  "ptnt",
  "qjn",
  "qmy",
  "qqjn",
  "qqmy",
  "scjn",
  "scmy",
  "styl",
  "tajx",
  "us-total-2x",
  "vbx",
  "voox",
  "wats",
  "webx",
  "wndr",
  "wr",
  "xa",
  "xagi",
  "xbix",
  "xcom",
  "xeur",
  "xhoa",
  "xiwc",
  "xkre",
  "xlbx",
  "xlex",
  "xlfx",
  "xlix",
  "xlkx",
  "xlpx",
  "xlux",
  "xlvx",
  "xlyx",
  "xpav",
  "xsem",
  "xtai",
  "xvo",
  "xvug",
  "xw",
  "yung",
]);
